<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>{{$t('Talent.Edit.Heading')}}</h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field" id="AC">
                            <label for="title2" id="AC2">{{$t('Talent.Edit.Active')}}</label>
                            <InputSwitch v-model="mydata.status" trueValue="active" />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Talent.Edit.Type')}}</label>
                            <InputText type="text" :class="`${error.sub_type ? 'p-invalid' : ''}`" :placeholder="$t('Talent.Edit.Heading')" id="title2" v-model="mydata.sub_type"></InputText>
                            <div class="text-red">{{ error.sub_type }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Talent.Edit.NoCases')}}</label>
                            <InputText type="text" :class="`${error.no_of_cases ? 'p-invalid' : ''}`" :placeholder="$t('Talent.Edit.NoCases')" id="title2" v-model="mydata.no_of_cases"></InputText>
                            <div class="text-red">{{ error.no_of_cases }}</div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{$t('Talent.Edit.Validdate')}}</label>
                            <InputText type="text" :class="`${error.validity_date ? 'p-invalid' : ''}`" :placeholder="$t('Talent.Edit.Validdate')" id="title2" v-model="mydata.validity_date"></InputText>
                            <div class="text-red">{{ error.validity_date }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="state2">{{$t('Talent.Edit.OriginalPrice')}}</label>
                            <InputText type="text" :class="`${error.original_price ? 'p-invalid' : ''}`" :placeholder="$t('Talent.Edit.OriginalPrice')" id="title2" @change="getpercentage" v-model="mydata.original_price"></InputText>
                            <div class="text-red">{{ error.original_price }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Talent.Edit.DiscountRate')}}</label>
                            <InputText type="text" :class="`${error.discount ? 'p-invalid' : ''}`" :placeholder="$t('Talent.Edit.DiscountRate')" id="title2" @change="getpercentage" v-model="mydata.discount"></InputText>
                            <div class="text-red">{{ error.discount }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2">{{$t('Talent.Edit.Offeredprice')}}</label>
                            <InputText type="text" :class="`${error.discounted_price ? 'p-invalid' : ''}`" :placeholder="$t('Talent.Edit.Offeredprice')" id="title2" v-model="mydata.discounted_price" disabled></InputText>
                            <div class="text-red">{{ error.discounted_price }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Talent.Edit.Save')" icon="pi pi-check" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="confirm($event)" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('Talent.Edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black;"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>
<script>
// import validateEditUser from '../../validations/user/validateEditUser';
import validateEditTalent from '../../../validations/Talent/validateEditTalent';
import TalentService from '../../../service/API/TalentService';
import moment from 'moment';
export default {
    data() {
        return {
            dropdownValues: [{ name: 'active' }, { name: 'inactive' }],
            dropdownItem: null,
            // modelname: JSON.parse(localStorage.getItem('desc')).description,

            mydata: {
                sub_type_id: '',
                sub_type: '',
                validity_date: '',
                discount: '',
                original_price: '',
                discounted_price: '',
                no_of_cases: '',
                status: '',
                
            },
            id:'',
            error: {},
        };
    },
    created() {
        this.talentService = new TalentService();
    },
    methods: {
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        cancel() {
            this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            setTimeout(() => {
                this.$router.go(-1);
            }, 2000);
        },
        SubmitForm() {},
        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '네',
                rejectLabel: ' 아니요',
                accept: () => {
                    console.log(this.mydata.discounted_price);
                    let vcheckData = {
                        sub_type: this.mydata.sub_type,
                        validity_date: this.mydata.validity_date,
                        original_price: this.mydata.original_price,
                        discount: this.mydata.discount,
                        discounted_price: this.mydata.discounted_price==0 ?'something':this.mydata.discounted_price,
                        no_of_cases: this.mydata.no_of_cases,

                        //     status: this.status ? 'active' : 'inactive',
                        //     file: this.image == '' ? '' : 'something',
                    };
                    const { isInvalid, error } = validateEditTalent(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                    this.talentService.editTalent({ sub_type_id: this.$route.params.sub_type_id, sub_type: this.mydata.sub_type, validity_date: this.mydata.validity_date, discount: this.mydata.discount,original_price: this.mydata.original_price, discounted_price: this.mydata.discounted_price, no_of_cases: this.mydata.no_of_cases,status: this.mydata.status == 'active' ? 'active' : 'inactive'}).then((res) => {
                        console.warn(res);
                        this.$router.push({ name: 'Talent Search' });
                        setTimeout(() => {
                            this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '인재 검색 정보가 저장되었습니다.', life: 3000 });
                        }, 500);
                    });
                }
                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },
        getpercentage() {
            if (this.mydata.original_price && this.mydata.discount) {
                this.mydata.discounted_price = (this.mydata.original_price - (this.mydata.discount / 100) * this.mydata.original_price);
            }
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        dateformat(value) {
            if (value) {
                return moment(String(value)).format('YYYY/MM/DD');
            }
        },
    },
    mounted() {
        this.talentService.viewTalent(this.$route.params.sub_type_id).then((res) => {
            this.mydata.status = res[0].status;
            this.mydata.original_price = res[0].original_price;
            this.mydata.discount = res[0].discount;
            this.mydata.discounted_price = res[0].discounted_price;
            this.mydata.sub_type = res[0].sub_type;
            this.mydata.validity_date = res[0].validity_date;
            this.mydata.no_of_cases = res[0].no_of_cases;
            console.log(res);
        });
    },
};
</script>

<style scoped>
.p-fluid .p-button {
    width: auto;
}
div#AC {
    display: flex;
}
label#AC2 {
    margin-right: 12px;
}
#Save{
background: black;color: white;
}
</style>
